import React from "react";
import ChatSidebarHeader from "./Header/Header.component";
import { StyledSidebarContainer } from "./Sidebar.style";
import ChatSidebarTabs from "./Tabs/Tabs.component";

const ChatSidebar = ({ tabs, selectedTab, setSelectedTab }) => (
  <StyledSidebarContainer>
    <ChatSidebarHeader tabs={tabs} setSelectedTab={setSelectedTab} />
    <ChatSidebarTabs
      tabs={tabs}
      selectedTab={selectedTab}
      setSelectedTab={setSelectedTab}
    />
  </StyledSidebarContainer>
);

export default ChatSidebar;
